import React from 'react'
import { humiEmptyState } from '../../../assets/assets'

const CalendarDayEmptyState = ({ humiIsabellaDisabled, strings }) => {
  return (
    <div className='calendar-day-empty-state'>
      {!humiIsabellaDisabled ? (
        <div className='calendar-day-empty-state-logo'>
          <img
            className='humi-empty-state'
            src={humiEmptyState}
            alt='calendar-humi'
          />
        </div>
      ) : null}
      <div className='calendar-day-empty-state-text'>
        {strings.no_activities_on_this_day || 'No activities on this day'}
      </div>
    </div>
  )
}

export default CalendarDayEmptyState
